import TemplateNames from '../email-messages/TemplateNames';

export default {
  template_names: TemplateNames,
  email_messages_page_title: 'Messages e-mail',
  labels: {
    view_full_message: 'Voir le message complet',
    status: 'Statut :',
    on: 'Activé',
    off: 'Désactivé',
    next_send: 'Prochain envoi : {{date}}.',
  },
  descriptions: {
    welcome:
      "Envoyé une seule fois lorsqu'un client s'abonne à vos e-mails marketing, hors inscriptions via le formulaire de votre vitrine. Un client ne reçoit qu'un seul e-mail parmi Bienvenue, Bienvenue au club des membres et Offre de lancement.",
    welcome_members_club:
      "Envoyé une seule fois lorsqu'une personne s'inscrit via le formulaire de votre vitrine sans code promo d'inscription configuré, ou rejoint votre liste de membres VIP. Un client ne reçoit qu'un seul e-mail parmi Bienvenue, Bienvenue au club des membres et Offre de lancement.",
    storefront_promo:
      "Envoyé une seule fois lorsqu'une personne s'inscrit via le formulaire de votre vitrine alors qu'un code promo d'inscription est configuré. L'e-mail contient son code promo personnel.",
    launch_deal:
      'Envoyé une seule fois à vos clients importés, 30 minutes après la mise en ligne de votre restaurant. Les clients ayant déjà reçu Bienvenue ou Bienvenue au club des membres sont ignorés.',
    we_miss_you:
      'Envoyé aux abonnés dont la dernière commande date de plus de 45 jours. Vérifié chaque matin ; un client le reçoit au maximum une fois tous les 45 jours.',
    happy_friday:
      'Envoyé à tous les abonnés à 08:00 UTC le premier vendredi de chaque mois pair (février, avril, juin, août, octobre, décembre).',
    lazy_sunday:
      'Envoyé à tous les abonnés à 08:00 UTC le premier dimanche de chaque mois impair (janvier, mars, mai, juillet, septembre, novembre).',
    loyalty_program:
      "Envoyé lorsque le solde de cashback d'un client atteint le minimum qu'il peut dépenser. Un client le reçoit au plus une fois tous les 30 jours.",
    you_might_also_like:
      "Envoyé 3 jours après une commande contenant au moins 2 fois le même article à 6,00 ou plus, en recommandant l'un de vos articles les plus populaires. Un client le reçoit au maximum une fois tous les 30 jours.",
  },
  tiles: {
    sends_count: 'Messages envoyés',
    delivery_rate: 'Taux de délivrabilité',
    delivered_suffix: 'délivrés',
    open_rate: "Taux d'ouverture",
    opened_suffix: 'ouverts',
    click_rate: 'Taux de clic',
    clicked_suffix: 'cliqués',
    spam_report_rate: 'Taux de signalement spam',
    spam_reports_suffix: 'signalements',
    unsubscribe_rate: 'Taux de désabonnement',
    unsubscribes_suffix: 'désabonnements',
  },
  toasts: {
    failed_to_update_status: 'Impossible de mettre à jour le statut',
    failed_to_load_data: 'Impossible de charger les données',
  },

  preview_modal: {
    title: 'Aperçu du modèle',
    labels: {
      subject: 'Objet :',
      close: 'Fermer',
    },
    toasts: {
      failed_to_load_data: "Impossible de charger l'aperçu",
    },
    template_data: {
      recipient_name: '&lt;Prénom&gt;',
    },
  },
};
